import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { planCategories } from 'src/lib/constants'

import { createPlanActions, getJdePriceStatus } from '../slice/createPlanSlice'

export const jdePriceStatusMiddleware = createListenerMiddleware()

/**
 * The subset of a fetched plan or unit document the middleware needs to decide
 * whether a JDE price/status lookup applies. Shell documents are out of scope.
 */
interface IJdeSourceDocument {
  communityPlanId?: string
  plan?: string
  planElevation?: string
  planId?: string
  planOverview?: {
    communityId?: string
    planCategory?: string
  }
  submitted?: boolean
  unitOverview?: {
    communityId?: string
    unitCategory?: string
    unitElevation?: string
  }
}

jdePriceStatusMiddleware.startListening({
  effect: async (action, listenerApi) => {
    const planDocument = action.payload as IJdeSourceDocument | undefined
    // The JDE overlay only applies to submitted community plans and units.
    if (!planDocument?.submitted || !planDocument.plan) {
      return
    }

    let communityId: string | undefined
    let communityPlanId: string | undefined
    let isCommunityCategory = false
    let planElevation: string | undefined

    if (planDocument.planOverview) {
      communityId = planDocument.planOverview.communityId
      communityPlanId = planDocument.planId
      isCommunityCategory =
        planDocument.planOverview.planCategory === planCategories.COMMUNITY
      planElevation = planDocument.planElevation
    } else if (planDocument.unitOverview) {
      communityId = planDocument.unitOverview.communityId
      communityPlanId = planDocument.communityPlanId
      isCommunityCategory =
        planDocument.unitOverview.unitCategory === planCategories.COMMUNITY
      planElevation = planDocument.unitOverview.unitElevation
    }

    if (isCommunityCategory && communityId && communityPlanId) {
      await listenerApi.dispatch(
        getJdePriceStatus({
          communityId,
          communityPlanId,
          plan: planDocument.plan,
          planElevation,
        })
      )
    }
  },
  matcher: isAnyOf(
    createPlanActions.getPlanDataByPlanId.fulfilled,
    createPlanActions.getUnitPlan.fulfilled
  ),
})
